import React, { useEffect, useState } from "react";
import axios from "axios";
import { Mic, Square, Loader2 } from "lucide-react";
import useMicRecorder from "../../hooks/useMicRecorder";
import { API, auth, TOK, SERIF, SANS } from "./shared";

// One large conversational box for the Explain step — type or speak.
export const ExplainInput = ({ value, onChange, placeholder, testId = "simple-tell-input", rows = 4 }) => {
  const mic = useMicRecorder();
  const [transcribing, setTranscribing] = useState(false);
  const [micError, setMicError] = useState("");

  useEffect(() => {
    if (mic.state !== "ready" || !mic.blob) return;
    const ext = (mic.mime || "").includes("mp4") ? "mp4" : "webm";
    const form = new FormData();
    form.append("file", mic.blob, `speech.${ext}`);
    setTranscribing(true);
    setMicError("");
    axios.post(`${API}/api/audio-journeys/ai/transcribe`, form, auth())
      .then((r) => {
        const t = r.data?.text || "";
        if (t) onChange((prev) => (prev ? `${prev.trim()} ${t}` : t));
        else setMicError("I didn't catch that — try again or type it.");
      })
      .catch(() => setMicError("I couldn't hear that clearly — try again or type it."))
      .finally(() => { setTranscribing(false); mic.reset(); });
  }, [mic.state, mic.blob]); // eslint-disable-line react-hooks/exhaustive-deps

  const recording = mic.state === "recording";
  return (
    <div>
      <div className="relative">
        <textarea value={value} onChange={(e) => onChange(e.target.value)} rows={rows} placeholder={placeholder} data-testid={testId}
          className="w-full rounded-2xl p-5 pr-16 outline-none resize-none text-lg placeholder:text-[#f5ecd9]/30 placeholder:italic"
          style={{ background: "rgba(245,236,217,0.05)", border: `1px solid ${TOK.goldMist}`, color: TOK.cream, fontFamily: SERIF }} />
        <button type="button" onClick={recording ? mic.stop : mic.start} disabled={transcribing} data-testid={`${testId}-mic`}
          aria-label={recording ? "Stop recording" : "Speak instead"}
          className="absolute right-3 bottom-4 w-11 h-11 rounded-full inline-flex items-center justify-center transition-transform duration-200 active:scale-95"
          style={{ background: recording ? "#c0584f" : TOK.gold, color: TOK.ink }}>
          {transcribing ? <Loader2 size={18} className="animate-spin" /> : recording ? <Square size={14} fill="currentColor" /> : <Mic size={18} />}
        </button>
      </div>
      {recording && <p className="mt-3 text-sm" style={{ color: TOK.gold, fontFamily: SANS }} data-testid={`${testId}-listening`}>Listening… tap to finish</p>}
      {(micError || mic.error) && <p className="mt-3 text-sm" style={{ color: "#e9a39c", fontFamily: SANS }}>{micError || mic.error}</p>}
    </div>
  );
};

export const MIN_EXPLAIN = 8;
